import { generalServiceV1API } from '@/store/api-instance'
import { IAuthUser } from '@/store/modules/auth/interfaces/IAuthUser'
import { permissionSchema, RolePermissionDetails } from '@/store/modules/users/interfaces/IUser'
import modals from '@/utils/modals'
import WarningModal from '@/components/modals/WarningModal.vue'
import i18n from '@/i18n'
import { Store } from 'vuex'
import { IRootState } from '@/store'

export default {
  methods: {
    allPermission (user: IAuthUser) {
      const permissionSchema = user?.permissionSchema
      return (
        permissionSchema
          ?.flatMap((company: permissionSchema) => company.rpDetails)
          ?.flatMap((rp: RolePermissionDetails) => rp.permission.split(','))
          ?.filter((value: string, index: number, self: Array<string>) => self.indexOf(value) === index) || []
      )
    },
    allRoles (user: IAuthUser) {
      const permissionSchema = user?.permissionSchema
      return (
        permissionSchema
          ?.flatMap((company: permissionSchema) => company.rpDetails)
          ?.flatMap((rp: RolePermissionDetails) => rp.rolename)
          ?.filter((value: string, index: number, self: Array<string>) => self.indexOf(value) === index) || []
      )
    },
    allCompanyDetails (user: IAuthUser) {
      const permissionSchema = user?.permissionSchema
      return permissionSchema.map((item: permissionSchema) => {
        return { label: item.companyName, value: item.companyId }
      })
    },
    shipToDetails (user: IAuthUser, addresses?: any) {
      const permissionSchema = user?.permissionSchema

      return permissionSchema.map((item: permissionSchema) => {
        const entry = addresses.find((address: any) => address.pe_idsap === item.shipToId)

        const addressParts = []
        let finalAddress = ''
        if (entry) {
          if (item?.shipToName) {
            addressParts.push(item?.shipToName)
          }
          if (entry?.address1_line1) {
            addressParts.push(entry.address1_line1)
          }
          if (entry?.pe_address1_housenumber) {
            addressParts.push(entry.pe_address1_housenumber)
          }
          if (entry?.address1_city) {
            addressParts.push(entry.address1_city)
          }

          finalAddress = addressParts.join(', ')
        } else {
          finalAddress = item.shipToAddress || ''
        }

        return { label: finalAddress, value: item.shipToId, company: item.companyId }
      })
    },
    checkDisableShipTo (user: IAuthUser, shipToId: string) {
      const permissionSchema = user?.permissionSchema || []

      if (shipToId != null) {
        return permissionSchema.some(
          (shipToItem: permissionSchema) => shipToItem.shipToId === shipToId && shipToItem.shipToStatus === 'SUSPENDED'
        )
      }

      if (permissionSchema.length === 1) {
        return permissionSchema[0]?.shipToStatus === 'SUSPENDED'
      }

      return false
    },
    checkDisableShipToWithName (user: IAuthUser, shipToName: string) {
      const permissionSchema = user?.permissionSchema || []

      if (shipToName != null) {
        return permissionSchema.some(
          (shipToItem: permissionSchema) =>
            shipToItem.shipToName === shipToName && shipToItem.shipToStatus === 'SUSPENDED'
        )
      }

      if (permissionSchema.length === 1) {
        return permissionSchema[0]?.shipToStatus === 'SUSPENDED'
      }

      return false
    },
    getCompanyid (shipToId: string, user: IAuthUser) {
      let companyId = ''
      const shipToItem = user?.permissionSchema.find((item: permissionSchema) => item.shipToId === shipToId)
      if (shipToItem) {
        companyId = shipToItem?.companyId
      }
      return companyId
    },
    async checkAlcoholLicense () {
      const customerType = localStorage.getItem('customertype')
      if (!customerType) {
        console.log('Waiting for customerType to load...')
        return
      }

      if (customerType !== 'Ontrade') {
        const { t: $t, d: $d, n: $n } = i18n.global

        const storedShipToId = sessionStorage.getItem('storedShipToId')
        const shipToId = localStorage.getItem('shipToId') || ''
        sessionStorage.setItem('storedShipToId', shipToId)

        const alcoholApi = 'alcohollicense/GetAlcholLicenseByShipto?ShipToId=' + shipToId
        try {
          const response = await generalServiceV1API.get(alcoholApi)
          const data = response.data[0]

          if (storedShipToId !== shipToId) {
            const validToDate: any = new Date(data?.validto)
            const currentDate: any = new Date()
            const timeDifference = validToDate - currentDate
            const daysDifference = timeDifference / (1000 * 60 * 60 * 24)

            let messageHeading = ''
            let messageSubHeading = ''
            if (data && Math.floor(daysDifference) === 1) {
              messageHeading = $t('The license for this ship to will end in 1 day')
            } else if (data && daysDifference > 1 && daysDifference <= 14) {
              messageHeading = $t('The license for this ship to will end in X days', { n: Math.floor(daysDifference) })
              messageSubHeading = $t('Please deliver a new one at least 4 days before it expires.')
            } else if (!data || (data && Math.floor(daysDifference) < 1)) {
              messageHeading = $t('The license for this ship to has expired')
              messageSubHeading = $t('The order will be sent to KP and will wait for a new document to be delivered.')
            }

            if ((daysDifference <= 14 || !data) && !sessionStorage.getItem('alcohol-license-open')) {
              sessionStorage.setItem('alcohol-license-open', 'true')
              modals.showModal({
                component: WarningModal,
                props: {
                  messageHeading,
                  messageSubHeading,
                  messageAdditional: $t('If it has already been delivered, please ignore this message.'),
                  primaryButtonText: $t('Okay!')
                },
                listeners: {
                  onClose: () => {
                    // sessionStorage.removeItem('alcohol-license-open');
                  }
                }
              })
            }
          } else {
            console.error('Invalid response data')
          }
        } catch (error) {
          console.error('Error fetching alcohol license:', error)
        }
      } else {
        console.error('Customer type is Ontrade; no modal needed.')
      }
    }
  }
}
